const STORAGE_KEY = "cc_recent_searches";
const MAX = 8;

function normalize(term: string) {
  return term.trim();
}

export function getRecentSearches(): string[] {
  if(typeof localStorage === "undefined") return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if(!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if(!Array.isArray(parsed)) return [];
    return parsed
      .filter((x): x is string => typeof x === "string")
      .map(normalize)
      .filter((x) => x.length >= 2)
      .slice(0, MAX);
  } catch {
    return [];
  }
}

export function addRecentSearch(q: string): string[] {
  const term = normalize(q);
  if(term.length < 2) return getRecentSearches();
  const prev = getRecentSearches().filter((x) => x.toLowerCase() !== term.toLowerCase());
  const next = [term, ...prev].slice(0, MAX);
  if(typeof localStorage !== "undefined") {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      /* ignore quota / private mode */
    }
  }
  return next;
}
